/*
 * @Descripttion: 请求文件
 * @version: 1.0
 * @Author: hayuu
 * @Date: 2024-09-09 09:54:08
 * @LastEditors: hayuu
 * @LastEditTime: 2025-04-21 11:56:52
 */
import axios from 'axios';
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store';
import { getToken, removeToken } from '@/utils/auth';
import errorCode from '@/utils/errorCode';
import router from '@/router/index';

// 是否显示重新登录
export let isRelogin = { show: false };
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	// baseURL: process.env.VUE_APP_BASE_API,
	// 超时
	timeout: 200000
});
// request拦截器
service.interceptors.request.use(
	(config) => {
		console.log("请求拦截器", config)
		// 是否需要设置 token
		if (config.url.indexOf('http') == -1) {
			config.baseURL = process.env.VUE_APP_BASE_API;
		}
		const isToken = (config.headers || {}).isToken === false;
		if (getToken() && !isToken) {
			if (

				/** 地市 -- 保德 */
				config.url.indexOf('/convenientService') == -1
				/** -- 其他 */
				// true
			) {
				// 除以上请求携带自定义token
				// config.headers['Authorization'] =getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
				config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
			}
		}
		/** 地市 -- 保德 */
		if (
			config.url.indexOf('/convenientService') != -1
		) {
			config.headers['Authorization'] = localStorage.getItem("serviceToken")
		} else if (config.url.indexOf('/personDeposit') != -1) {
			config.headers['areaId'] = 14113020200017
			// config.headers['areaId'] = JSON.parse(localStorage.getItem("area")).code
		}




		// if (
		// 	config.url.indexOf('http://59.195.207.70:19086/service') != -1
		// ) {
		// 	config.headers['Content-Type'] = "application/json; charset=utf-8"
		// 	config.headers['C-Tenancy-Id'] = "140000000000"
		// 	config.headers['C-App-Id'] = "SXXZYS_SJT_APP_001"
		// 	config.headers['C-Business-Id'] = Math.round(Math.random() * 10000)
		// 	config.headers['C-App-Pwd'] = "QR7Znc6B5A"
		// 	config.headers['C-Dynamic-Password-Foruser'] = ""
		// }
		// get请求映射params参数
		if (config.method === 'get' && config.params) {
			let url = config.url + '?';
			for (const propName of Object.keys(config.params)) {
				const value = config.params[propName];
				var part = encodeURIComponent(propName) + '=';
				if (value !== null && typeof value !== 'undefined') {
					if (typeof value === 'object') {
						for (const key of Object.keys(value)) {
							let params = propName + '[' + key + ']';
							var subPart = encodeURIComponent(params) + '=';
							url += subPart + encodeURIComponent(value[key]) + '&';
						}
					} else {
						url += part + encodeURIComponent(value) + '&';
					}
				}
			}
			url = url.slice(0, -1);
			config.params = {};
			config.url = url;
		}
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

// 响应拦截器
service.interceptors.response.use(
	(res) => {
		console.log('响应拦截', res)
		if (res.status !== 200) {
			router.push('/error')
			return Promise.reject(res)
		}
		// 未设置状态码则默认成功状态
		const code = res.data.code || 200;
		// 获取错误信息
		const msg = errorCode[code] || res.data.msg || errorCode['default'];
		if (code === 401) {
			// MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
			// 	confirmButtonText: '重新登录',
			// 	cancelButtonText: '取消',
			// 	type: 'warning'
			// }).then(() => {
			// 	store.dispatch('LogOut').then(() => {
			// 		location.href = '/index';
			// 	})
			// })

			store.dispatch('LogOut').then(() => {
				store.loginShow = true
			})
		} else if (code === 500) {
			router.push('/error')
			if (
				res.config.url.indexOf('/auth/sxzwAuth/login') == -1
			) {
				return Promise.reject(msg);
			} else {
				return Promise.reject(msg);
			}
		} else if (code !== 200) {
			// router.push('/error')
			if (code == 501 || code == 502 || code == 505) {
				return Promise.reject({ code: code, msg: msg });
			}
			else if (code == 506) {
				router.push('/exploit')
			}
			else {
				return Promise.reject(msg);
			}
		} else if (res.data.code == 600016 || res.data.message == '非法授权访问，非法入参') {
			let device_id = localStorage.getItem("device_id")
			localStorage.clear();
			localStorage.setItem("device_id", device_id);
			MessageBox.confirm({
				title: '系统提示',
				message: '登录状态已过期，请重新进行登录',
				confirmButtonText: '确认',
				confirmButtonColor: "#497EEE",
			})
				.then(() => {
					router.push('/login')
				})
			return res.data;
		}
		else {
			return res.data;
		}
	},
	(error) => {
		let { message } = error;
		console.log('错误响应', message.includes('Request failed with status code'), error);
		router.push('/error')
		if (message == 'Network Error') {
			message = '后端接口连接异常';
		} else if (message.includes('timeout')) {
			message = '系统接口请求超时';
		} else if (message.includes('Request failed with status code')) {
			message = '系统接口' + message.substr(message.length - 3) + '异常';
			if (Number(message.substr(4, 3)) === 401) {
				removeToken();
				router.go(0);
			}
		}
		return Promise.reject(error);
	}
);

export default service;
